import moment from "moment";

const fmt = require("indian-number-format");

export default function InterestBillCard(props) {
  const item = props.item;

  return (
    <div className="menuContainer addHight text">
      <div className="menuExchange uppercase">
        {fmt.format(item.deposit_total)}
      </div>
      <div className="menuExchange uppercase">
        {fmt.format(item.deposit_current)}
      </div>
      <div className="menuExchange uppercase">
        {fmt.format(item.deposit_available)}
      </div>
      <div className="menuExchange uppercase">
        {fmt.format(item.deposit_use)}
      </div>
      <div className="menuExchange uppercase">
        {fmt.format(item.deposit_interest_amt)}
      </div>
      <div className="menuExchange uppercase selltext">
        {fmt.format(item.interest_amount)} ({item.interest_rate})
      </div>

      <div className="menuExchange small">
        {moment(item.date_created).format("DD-MM-YYYY HH:mm:ss")}
      </div>
    </div>
  );
}
